import { Component } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { patternfirstNamechiffre, patternEmail, linkedInRegExp } from '@core/models/pattern';
import { EsnConsultantService } from '@core/services/esn-consultant/esn-consultant.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { PrimeNGConfig } from 'primeng/api';

@Component({
  selector: 'app-add-consultant',
  templateUrl: './add-consultant.component.html',
  styleUrls: ['./add-consultant.component.css']
})
export class AddConsultantComponent {

    formconsultant: FormGroup = this.createconsultantForm();

    isexistemail = false;
    iscv:boolean=false
    isButtonDisabled: boolean = false;
    isvalid: boolean = false;
    showResetButtons: boolean = true;

    errorMessage: string = '';
    errorMessageprofil: string = '';
    fileName: string = '';
    fileError: string = '';
    fileExtention: string = '';

    selectedconsultant: any;
    candidat_id: any;
    company_name: any;
    file: any = '';
    listclient: { id: number; name: string; uuid: string }[] = [];
    client: any[] = [];
    clientList : any[] = [];
    listmanager: {
      uuid: string; id: number; full_name: string, first_name: string, last_name: string 
    }[] = [];
    isFromAppplication: boolean = false;

    constructor (
      private formBuilder: FormBuilder,
      private esnconsultantservice: EsnConsultantService,
      private router: Router,
      private toastrService: ToastrService,
      private spinner: NgxSpinnerService,
      private primengConfig: PrimeNGConfig,
    ) {

      const navigation = this.router.getCurrentNavigation();
      const navigationData = navigation?.extras.state?.['data']
       if (navigationData?.type === '1' && navigationData?.email?.length ) {
        this.isFromAppplication = true;
          this.getconsultantByEmail(null, navigationData?.email);
          this.formconsultant.get('email')?.disable();
       }

      this.primengConfig.setTranslation({
        dayNames: ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"],
        dayNamesShort: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"],
        dayNamesMin: ["D", "L", "M", "M", "J", "V", "S"],
        monthNames: ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"],
        monthNamesShort: ["Jan", "Fév", "Mar", "Avr", "Mai", "Juin", "Juil", "Aoû", "Sep", "Oct", "Nov", "Déc"],
        today: 'Aujourd\'hui',
        clear: 'Effacer'
      });
    }

    ngOnInit(): void {
      this.getListclient();
      this.getListmanager();
      
    }

    getListmanager() {
      this.esnconsultantservice.getmanagernew().subscribe({
        next: (response) => {
          if (response.data) {
            this.listmanager = response.data.map((el: any) => {
              return {
                ...el,
                full_name: `${el.first_name} ${el.last_name}`
              };
            });
          }
        },
        error: (error) => {
        },
      });
    }

    getListclient() {
      this.spinner.show();
      this.esnconsultantservice.getclient().subscribe({
        next: (response) => {
          if (response.data) {
            this.listclient = response.data;
            this.client = response.data;
            this.clientList = this.client.map(item=> item.name);
            this.spinner.hide();
          }
        },
        error: (error) => {
          this.spinner.hide();
        },
      });
    }

    createconsultantForm(data?: any) {
        return this.formBuilder.group(
          {
            first_name: [
              data?.first_name || '',
              [Validators.required, Validators.pattern(patternfirstNamechiffre)],
            ],
            last_name: [
              data?.last_name || '',
              [Validators.required, Validators.pattern(patternfirstNamechiffre)],
            ],
            emailProESN: [
              data?.emailProESN || '',
              [Validators.pattern(patternEmail)],
            ],
            email: [
              data?.email || '',
              [Validators.required, Validators.pattern(patternEmail)],
            ],
            linkedin_link: [data?.linkedin_link || ''],
            cv: [data?.cv || ''],
            desired_workstation: [data?.desired_workstation || ''],
            date_signature_contrat: [data?.date_signature_contrat || ''],
            salary: [data?.salary || null],
            tjm_achat: [data?.tjm_achat || ''],
            tjm_vente: [data?.tjm_vente || ''],
            manager_id: [data?.manager_id || null],
            client_id: [data?.client_id?data?.client_id:data?.client_id2 || null],
            candidate_id: [data?.candidate_id || ''],
            mission_start_date: [{ value: '', disabled: true }],
            mission_end_date: [{ value: '', disabled: true }],
            mobility: [data?.mobility || []],
            desired_contract: [data?.desired_contract || []],
            softSkills: [data?.softSkills || []],
            destination_country: [data?.destination_country || []],
            contract_type: [data?.contract_type || []],
            skills_text: [data?.skills_text || []],
          },
          { validator: this.dateRangeValidator }
        );
      }

      dateRangeValidator(
          control: AbstractControl
        ): { [key: string]: boolean } | null {
          const startDate = control.get('mission_start_date')!.value;
          const endDate = control.get('mission_end_date')!.value;

          if (startDate && endDate && startDate > endDate) {
            return { dateRangeInvalid: true };
          }
      
          return null;
        }
  
        getconsultantByEmail(event: any, applyEmail?: string) {
          this.errorMessage = '';
          //this.formconsultant.reset();
          const enteredEmail = applyEmail?.length ? applyEmail : event.target.value.trim();
      
          if (enteredEmail === '') {
            this.enableFormFields();
            this.formconsultant.get('linkedin_link')?.enable();
            this.selectedconsultant = null;
            this.formconsultant.patchValue({
              first_name: '',
              last_name: '',
              linkedin_link: '',
              cvName: '',
              desired_workstation: '',
            });
            this.isexistemail = false;
            this.isButtonDisabled = false;
            this.errorMessage = '';
            return;
          }
      
          this.esnconsultantservice
            .getconsultantbyemail(enteredEmail)
            .subscribe({
              next: (res: any) => {
                if (res.status === 200) {
                  this.isexistemail = true;
                  if(res.data.cv && res.data.cv!=='null'){
                    this.iscv=true
                   }
                   else{
                    this.iscv=false
                   }
      
                  this.formconsultant.get('linkedin_link')?.enable();
                  this.company_name = res.company_name;
                  this.selectedconsultant = res.data.cv;
                  this.candidat_id = res.data.uuid;
                  if (enteredEmail !== res.data.email) {
                    this.formconsultant.get('linkedin_link')?.enable();
                    this.formconsultant.patchValue({
                      first_name: '',
                      last_name: '',
                      selectedconsultant: '',
                      desired_workstation: '',
                    });
                    this.isexistemail = false;
                    this.isButtonDisabled = false;
                    this.errorMessage = '';
                    return;
                  }
      
                  this.formconsultant.patchValue({
                    email: res.data.email,
                    first_name: res.data.first_name,
                    last_name: res.data.last_name,
                    linkedin_link: res.data.linkedin_link,
                    cv: res.data.cv,
                    desired_workstation: res.data.desired_workstation,
                    client_name: res.client_name,
                  });
                  if (res.data.cv) {
                    this.file = { name: res.data.cv };
                  }
      
                  this.errorMessage = '';
                  this.isButtonDisabled = false;
      
                  if (
                    res.data.linkedin_link !== null &&
                    res.data.linkedin_link !== ''
                  ) {
                    this.formconsultant.get('linkedin_link')?.disable();
                  } else {
                    this.formconsultant.get('linkedin_link')?.enable();
                  }
      
                  this.disableFormFields();
                } else {
                  this.isexistemail = true;
      
                  this.isButtonDisabled = false;
                  this.errorMessage = '"Utilisateur associé à une autre ESN."';
                   this.formconsultant.get('email')?.enable();
                  this.formconsultant.patchValue({
                      email: enteredEmail? enteredEmail : '',
                });
                }
              },
              error: (error: any) => {
                this.isexistemail = false;
                this.iscv=false
                this.enableFormFields()
                this.selectedconsultant = null
                this.formconsultant.patchValue({
                  first_name: '',
                  last_name: '',
                  selectedconsultant: '',
                  desired_workstation: '',
                  cv:'',
                  linkedin_link:'',
                });
                if (
                  error?.error?.message === 'User already associated with this ESN'
                ) {
                  this.isexistemail = true;
                  this.isButtonDisabled = true;
                  this.errorMessage = '"Utilisateur associé à cet ESN."';
                }
                if (error?.error?.message === 'User associated with another ESN') {
                  this.isexistemail = true;
                  this.isButtonDisabled = false;
                  this.errorMessage = '"Utilisateur associé à une autre ESN."';
                  this.formconsultant.get('email')?.enable();
                  this.formconsultant.patchValue({
                    email: enteredEmail? enteredEmail : '',
                  });
                }
                if (error?.error?.message === 'User profile was not completed') {
                  this.isexistemail = true;
                  this.isButtonDisabled = true;
                  this.errorMessageprofil = '"Le profil utilisateur n\'a pas été complété"';
                }
              },
            });
          if (
            this.formconsultant.value.linkedin_link === undefined &&
            this.formconsultant.value.cv === undefined &&
            this.formconsultant.value.cv !== null &&
            this.formconsultant.value.linkedin_link !== null
          ) {
            this.isvalid = true;
          } else {
            this.isvalid = false;
          }
        }

        enableFormFields() {
          if (this.formconsultant) {
            this.formconsultant.get('first_name')?.enable();
            this.formconsultant.get('last_name')?.enable();
            this.formconsultant.get('emailProESN')?.enable();
            this.formconsultant.get('linkedin_link')?.enable();
            this.formconsultant.get('desired_workstation')?.enable();
            this.formconsultant.get('cv')?.enable();
          }
        }

        disableFormFields() {
          if (this.formconsultant) {
            this.formconsultant.get('first_name')?.disable();
            this.formconsultant.get('last_name')?.disable();
            this.formconsultant.get('desired_workstation')?.disable();
          }
        }

      setValidatorRequirements() {
          const linkedinControl = this.formconsultant.get('linkedin_link');
          const cvControl = this.formconsultant.get('cv');
      
          // Effacer les validateurs existants
          linkedinControl?.clearValidators();
          cvControl?.clearValidators();
      
          if (!linkedinControl?.value && !cvControl?.value) {
            linkedinControl?.setValidators([
              Validators.pattern(linkedInRegExp),
            ]);
          } else {
            if (linkedinControl?.value) {
              linkedinControl?.setValidators([Validators.pattern(linkedInRegExp)]);
            }
            if (cvControl?.value) {
              cvControl?.clearValidators();
              // linkedinControl?.clearValidators();
            }
          }
      
          linkedinControl?.updateValueAndValidity({ emitEvent: false });
          cvControl?.updateValueAndValidity({ emitEvent: false });
        }

      uploadFile(event: any) {
        this.file = event.target.files[0];
        const maxSize = 2 * 1024 * 1024;
        this.fileName = this.file.name;
        if (this.file) {
          const allowedExtensions = ['.pdf', '.docx', '.doc'];
          const fileExtension = this.file.name
            .toLowerCase()
            .substr(this.file.name.lastIndexOf('.'));

          if (!allowedExtensions.includes(fileExtension)) {
            this.fileExtention = 'Format fichier non compatible !';
          } else if (this.file.size > maxSize) {
            this.fileError = 'Le fichier à importer ne doit pas depasser 2 méga !';
          } else {
            this.fileError = '';
            this.fileExtention = '';
          }
        }
        this.formconsultant.get('cv')?.setValue(this.file);
      }

      resetCV() {
        const inputFile = document.getElementById('cv') as HTMLInputElement;
        if (inputFile) {
          inputFile.value = '';
          this.fileExtention = '';
          this.fileError = '';
          this.isvalid = true;
        }
        this.fileName = '';
        this.showResetButtons = true;
      }

      isDateRangeValid(): boolean {
        return !this.formconsultant.hasError('dateRangeInvalid');
      }

      /* go to suggestion job request */
      navigateToListConsultant() {
        this.router.navigate(['/consultants',]);
      }

      createconsultant() {
        this.spinner.show();
        this.formconsultant.markAllAsTouched();
        this.formconsultant.markAsDirty();
        this.setValidatorRequirements();
    
        if (!this.isexistemail) {
    
          let fromdata = new FormData();
          fromdata.append('first_name', this.formconsultant.value.first_name);
          fromdata.append('last_name', this.formconsultant.value.last_name);
          fromdata.append('email', this.formconsultant.value.email);
          if (this.formconsultant.value.emailProESN) {
            fromdata.append('emailProESN', this.formconsultant.value.emailProESN);
          }
          if(this.formconsultant.value.date_signature_contrat)
          {
            fromdata.append('date_signature_contrat', this.formconsultant.value.date_signature_contrat);
          }
          if(this.formconsultant.value.linkedin_link){
          fromdata.append('linkedin_link', this.formconsultant.value.linkedin_link)
          };
          if( this.formconsultant.value.desired_workstation)
          {
            fromdata.append('desired_workstation',this.formconsultant.value.desired_workstation );
          }
          if (this.formconsultant.value.tjm_achat) {
            fromdata.append('tjm_achat', this.formconsultant.value.tjm_achat);
          }
          if (this.formconsultant.value.tjm_vente) {
            fromdata.append('tjm_vente', this.formconsultant.value.tjm_vente);
          }
          if (this.formconsultant.value.salary) {
            fromdata.append('salary', this.formconsultant.value.salary);
          }
          if (this.formconsultant.value.manager_id) {
            fromdata.append('manager_id', this.formconsultant.value.manager_id);
          }
          if (this.formconsultant.value.client_id) {
            fromdata.append('client_id', this.formconsultant.value.client_id);
          }

          if (this.formconsultant?.get('mission_start_date')?.value) {
            fromdata.append('mission_start_date', this.formconsultant?.get('mission_start_date')?.value);
          }
          if (this.formconsultant?.get('mission_end_date')?.value) {
            fromdata.append('mission_end_date', this.formconsultant?.get('mission_end_date')?.value);
          }
          if (this.file) {
            fromdata.append('cv', this.file);
          } 
    
          if (this.formconsultant.invalid) {
            return;
          }
          this.enableFormFields();
          this.esnconsultantservice.createconsultant(fromdata).subscribe({
            next: (response) => {
              this.toastrService.success('consultant a été ajouté avec succès');
              this.spinner.hide();
              this.navigateToProfile(response.data?.user_id);
                },
            error: (error: any) => {              
              this.spinner.hide();
              if (error?.status === 404) {
                this.toastrService.error('Utilisateur associé à une autre ESN.');
              } else if (error.error.message && typeof error.error.message === 'string') {
                this.toastrService.error(error.error.message);
              } else if (error?.error && error?.error?.data) {
                if (
                  error.error.data.email &&
                  error.error.data.email[0] === 'The email has already been taken.'
                ) {
                  this.toastrService.error("L'email est déjà utilisé.");
                } else if (
                  error.error.data.linkedin_link &&
                  error.error.data.linkedin_link[0] ===
                    'The linkedin link must be a valid URL.'
                ) {
                  this.toastrService.error(
                    'Le lien LinkedIn doit être une URL valide.'
                  );
                } else if (
                  error.error.data.cv &&
                  error.error.data.cv[0] === 'The cv field is required.'
                ) {
                  this.toastrService.error('Le CV est requis.');
                } else if (
                  error.error.data.linkedin_link &&
                  error.error.data.linkedin_link[0] ===
                    'The linkedin link has already been taken.'
                ) {
                  this.toastrService.error('LinkedIn est déjà utilisé.');
                } else  if (error.status === 403 && error.error.message) {
                  this.toastrService.error(error.error.message);
              } else if (error.error.message.includes('This user is an employee.')) {
                this.toastrService.error("Cet utilisateur est déjà associé à une entreprise");
              } else {
                this.toastrService.error("Une erreur inattendue s'est produite.");
              }
              }}
    
          });
        }
        else {
          if (this.company_name == null) {
            let data = {
              //candidate_id: this.candidat_id,
              //salary: this.formconsultant.value.salary,
    
              //tjm_achat: this.formconsultant.value.tjm_achat,
              //tjm_vente: this.formconsultant.value.tjm_vente,
              // emailProESN: this.formconsultant.value.emailProESN,
             // mission_start_date: this.formconsultant?.get('mission_start_date')?.value,
              //mission_end_date: this.formconsultant?.get('mission_end_date')?.value,
              // manager_id: this.formconsultant.value.manager_id
              //   ? this.formconsultant.value.manager_id
              //   : '',
              // client_id: this.formconsultant.value.client_id
              //   ? this.formconsultant.value.client_id
              //   : '',
              // date_signature_contrat:
              //   this.formconsultant.value.date_signature_contrat,
              //desired_workstation: this.formconsultant.value.desired_workstation,
            };






            let fromdata = new FormData();
          fromdata.append('candidate_id', this.candidat_id);
          if (this.formconsultant.value.emailProESN) {
            fromdata.append('emailProESN', this.formconsultant.value.emailProESN);
          }
          if(this.formconsultant.value.date_signature_contrat)
          {
            fromdata.append('date_signature_contrat', this.formconsultant.value.date_signature_contrat);
          }
          if(this.formconsultant.value.linkedin_link){
          fromdata.append('linkedin_link', this.formconsultant.value.linkedin_link)
          };
          if( this.formconsultant.value.desired_workstation)
          {
            fromdata.append('desired_workstation',this.formconsultant.value.desired_workstation );
          }
          if (this.formconsultant.value.tjm_achat) {
            fromdata.append('tjm_achat', this.formconsultant.value.tjm_achat);
          }
          if (this.formconsultant.value.tjm_vente) {
            fromdata.append('tjm_vente', this.formconsultant.value.tjm_vente);
          }
          if (this.formconsultant.value.salary) {
            fromdata.append('salary', this.formconsultant.value.salary);
          }
          if (this.formconsultant.value.manager_id) {
            fromdata.append('manager_id', this.formconsultant.value.manager_id);
          }
          if (this.formconsultant.value.client_id) {
            fromdata.append('client_id', this.formconsultant.value.client_id);
          }

          if (this.formconsultant?.get('mission_start_date')?.value) {
            fromdata.append('mission_start_date', this.formconsultant?.get('mission_start_date')?.value);
          }
          if (this.formconsultant?.get('mission_end_date')?.value) {
            fromdata.append('mission_end_date', this.formconsultant?.get('mission_end_date')?.value);
          }
          if (this.file) {
            fromdata.append('cv', this.file);
          } 
    
          if (this.formconsultant.invalid) {
            return;
          }


            this.disableFormFields();
            this.esnconsultantservice.createconsultant(fromdata).subscribe({
              next: (response) => {
                this.toastrService.success('consultant a été ajouté avec succès ');
                this.navigateToProfile(response.data?.user_id);
                this.spinner.show();
              },
              error: (error: any) => {
                this.spinner.hide();
                if (error?.status === 404) {
                  this.toastrService.error('Utilisateur associé à une autre ESN.');
                } else if (error?.error && error?.error?.data) {
                  if (
                    error.error.data.email &&
                    error.error.data.email[0] ===
                      'The email has already been taken.'
                  ) {
                    this.toastrService.error("L'email est déjà utilisé.");
                  } else if (
                    error.error.data.linkedin_link &&
                    error.error.data.linkedin_link[0] ===
                      'The linkedin link must be a valid URL.'
                  ) {
                    this.toastrService.error(
                      'Le lien LinkedIn doit être une URL valide.'
                    );
                  } else if (
                    error.error.data.cv &&
                    error.error.data.cv[0] === 'The cv field is required.'
                  ) {
                    this.toastrService.error('Le CV est requis.');
                  } else if (
                    error.error.data.linkedin_link &&
                    error.error.data.linkedin_link[0] ===
                      'The linkedin link has already been taken.'
                  ) {
                    this.toastrService.error("L'linkedin est déjà utilisé.");
                  }
                  else if (
                    error.error && error.error.message ==='candidate was already a salary'
                  ) {
                    this.toastrService.error("La candidate est déjà salariée.");
                  } else if (error.error.message.includes('This user is an employee.')) {
                    this.toastrService.error("Cet utilisateur est déjà associé à une entreprise");
                  } else {
                    this.toastrService.error(
                      "Une erreur inattendue s'est produite."
                    );
                  }
                } else {
                  this.toastrService.error("Une erreur inattendue s'est produite.");
                }
              },
            });
          } else {
            let data = {
              candidate_id: this.candidat_id,
              salary: this.formconsultant.value.salary,
              tjm_achat: this.formconsultant.value.tjm_achat,
              tjm_vente: this.formconsultant.value.tjm_vente,
    
              emailProESN: this.formconsultant.value.emailProESN,
              mission_start_date: this.formconsultant?.get('mission_start_date')?.value,
              mission_end_date: this.formconsultant?.get('mission_end_date')?.value,
              manager_id: this.formconsultant.value.manager_id
                ? this.formconsultant.value.manager_id
                : '',
              client_id: this.formconsultant.value.client_id
                ? this.formconsultant.value.client_id
                : '',
              date_signature_contrat:
                this.formconsultant.value.date_signature_contrat,
            };
            this.disableFormFields();
            this.esnconsultantservice.createconsultant(data).subscribe({
              next: (response) => {
                this.toastrService.success('consultant a été ajouté avec succès ');
                this.spinner.hide();
                this.navigateToProfile(response.data?.user_id);
              },
              error: (error: any) => {
                this.spinner.hide();
                if (error?.error?.message === 'This user is an employee.') {
                  this.toastrService.error('Utilisateur associé à une autre ESN.');
                } else if (error?.error && error?.error?.data) {
                  if (
                    error.error.data.email &&
                    error.error.data.email[0] ===
                      'The email has already been taken.'
                  ) {
                    this.toastrService.error("L'email est déjà utilisé.");
                  } else if (
                    error.error.data.linkedin_link &&
                    error.error.data.linkedin_link[0] ===
                      'The linkedin link must be a valid URL.'
                  ) {
                    this.toastrService.error(
                      'Le lien LinkedIn doit être une URL valide.'
                    );
                  } else if (
                    error.error.data.cv &&
                    error.error.data.cv[0] === 'The cv field is required.'
                  ) {
                    this.toastrService.error('Le CV est requis.');
                  } else if (
                    error.error.data.linkedin_link &&
                    error.error.data.linkedin_link[0] ===
                      'The linkedin link has already been taken.'
                  ) {
                    this.toastrService.error("L'linkedin est déjà utilisé.");
                  } else if (error.error.message.includes('This user is an employee.')) {
                    this.toastrService.error("Cet utilisateur est déjà associé à une entreprise");
                  } else {
                    this.toastrService.error(
                      "Une erreur inattendue s'est produite."
                    );
                  }
                } else {
                  this.toastrService.error("Une erreur inattendue s'est produite.");
                }
              },
            });
          }
        }
      }

      navigateToProfile(consultantUuid: any) {
        this.router.navigate([
          '/candidats/profilecandidatesn',
          consultantUuid,
        ]);
      }

      navigateCancel() {
        const url = this.isFromAppplication ? '/offres-emploi/candidature' : '/consultants';
        this.router.navigate([url]);
      }
}
